var React = require('react');

function ArrowNarrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Media / Icon/Filled/arrow-narrow-right"},React.createElement("path",{"id":"Icon","fillRule":"evenodd","clipRule":"evenodd","d":"M14.4075 7.05754C14.8176 6.64749 15.4824 6.64749 15.8924 7.05754L20.0924 11.2575C20.5025 11.6676 20.5025 12.3324 20.0924 12.7425L15.8924 16.9425C15.4824 17.3525 14.8176 17.3525 14.4075 16.9425C13.9975 16.5324 13.9975 15.8676 14.4075 15.4575L16.8151 13.05H4.64998C4.07008 13.05 3.59998 12.5799 3.59998 12C3.59998 11.4201 4.07008 10.95 4.64998 10.95H16.8151L14.4075 8.54246C13.9975 8.13241 13.9975 7.46759 14.4075 7.05754Z"})));
}

ArrowNarrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = ArrowNarrowRight;

ArrowNarrowRight.default = ArrowNarrowRight;
